import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {BoxScoresWidgetState} from "./models/box-scores-widget.state";
import {BoxScoresWidgetConfig} from "./box-scores-widget.config";

export class BoxScoresWidgetStore extends BaseMobxStore {
  static injectables = [BoxScoresWidgetConfig, BoxScoresWidgetState];
}

